import * as RP from '@radix-ui/react-popover';
import type { ComponentProps } from 'react';
import { cn } from '../lib/cn.ts';

/**
 * A panel anchored to a trigger: rich content a menu cannot hold (the notification centre),
 * or a quick in-place edit that does not block (assign an item, pick people). Menus of
 * commands use DropdownMenu; decisions use Dialog. Callers set the width and padding.
 */
export const Popover = RP.Root;
export const PopoverTrigger = RP.Trigger;
export const PopoverAnchor = RP.Anchor;
export const PopoverClose = RP.Close;

/** The anchored-overlay chrome shared with menus: raised surface, quiet edge, card radius, elevation 1, a 200 ms fade and 4 px slide in. */
export const POPOVER_SURFACE = 'z-(--z-dropdown) overflow-hidden rounded-card border border-border bg-raised text-ui text-fg shadow-elevation-1 outline-hidden motion-menu';

export function PopoverContent({ className, sideOffset = 6, align = 'end', ...rest }: ComponentProps<typeof RP.Content>) {
  return (
    <RP.Portal>
      <RP.Content sideOffset={sideOffset} align={align} collisionPadding={8} className={cn(POPOVER_SURFACE, className)} {...rest} />
    </RP.Portal>
  );
}
